// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"VideoPlayer_videoPlayer__hj1_1","loading":"VideoPlayer_loading__kdUgR","error":"VideoPlayer_error__QJ9G0"};